import '../../reset.css';
import '../../general_styles.css';
import './addons_styles.css';

import NavigationMenu from '../../components/Navigation';
import Titleform from '../../components/Title_form';
import BtnTransition from '../../components/Buttons_Transition';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormValueContext } from '../../contexts/formValues';
import { useContext } from 'react';

function Addons() {

    let totalAddOns = 0;

    const { onlineservice, setOnlineService, largerStorage, setLargerStorage, customProfile, setCustomProfile, isYearly, totalPrice, setTotalPrice, textPricePlan } = useContext(FormValueContext);
    //create others states for the others services

    const navigate = useNavigate();

    function onlineClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setOnlineService(!onlineservice);
        console.log(`ONLINE SERVICE AFTER:${onlineservice}`);

    }

    function storageClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setLargerStorage(!largerStorage);
        console.log(`STORAGE SERVICE AFTER:${largerStorage}`);
    }

    function profileClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setCustomProfile(!customProfile);
        console.log(`PROFILE SERVICE AFTER:${customProfile}`);

    }

    const submitAddOn = (e) => {
        e.preventDefault();

        if (isYearly) {
            console.log('BBBBBBBBBBBBBBBBBBBBBBBBB');
            if (onlineservice) {
                totalAddOns += 10;
            }
            if (largerStorage) {
                totalAddOns += 20;
            }
            if (customProfile) {
                totalAddOns += 20;
            }
        } else {
            console.log('CCCCCCCCCCCCCCCCCCCCCCCCCCCCCC');
            if (onlineservice) {
                totalAddOns++;
            }
            if (largerStorage) {
                totalAddOns += 2;
            }
            if (customProfile) {
                totalAddOns += 2;
            }
        }

        setTotalPrice(totalAddOns);

        navigate('/summary');
    };


    return (
        <div className='page__container'>
            <div className='form__container'>
                <NavigationMenu />
                <form className='form' onSubmit={(e) => submitAddOn(e)}>
                    <Titleform title='Pick add-ons' text='Add-ons help enhance your gaming experience.' />
                    <div className='form__addons'>
                        <label htmlFor='online_service' className='addon__card-label' style={{ 'borderColor': `${onlineservice ? 'hsl(213, 96%, 18%)' : 'var(--grey-light'}` }} onClick={(e) => onlineClick(e)} >
                            <input id='online_service' type='checkbox' checked={onlineservice}></input>
                            <div className='addon__card-texts'>
                                <h3 className='addon__card-title'>Online Service</h3>
                                <p className='addon__card-text'>Access to multiplayer games</p>
                            </div>
                            <p className='addon__card-price'>{`${isYearly ? '$10/yr' : '$1/mo'}`}</p>
                        </label>
                        <label className='addon__card-label' htmlFor='larger_storage' style={{ 'borderColor': `${largerStorage ? 'hsl(213, 96%, 18%)' : 'var(--grey-light'}` }} onClick={(e) => storageClick(e)}>
                            <input id='larger_storage' type='checkbox' checked={largerStorage}></input>
                            <div className='addon__card-texts'>
                                <h3 className='addon__card-title'>Larger Storage</h3>
                                <p className='addon__card-text'>Extra 1TB of cloud save</p>
                            </div>
                            <p className='addon__card-price'>{`${isYearly ? '$20/yr' : '$2/mo'}`}</p>
                        </label>
                        <label className='addon__card-label' htmlFor='custom_profile' style={{ 'borderColor': `${customProfile ? 'hsl(213, 96%, 18%)' : 'var(--grey-light'}` }} onClick={(e) => profileClick(e)}>

                            <input id='custom_profile' type='checkbox' checked={customProfile}></input>
                            <div className='addon__card-texts'>
                                <h3 className='addon__card-title'>Customizable Profile</h3>
                                <p className='addon__card-text'>Custom theme on your profile</p>
                            </div>
                            <p className='addon__card-price'>{`${isYearly ? '$20/yr' : '$2/mo'}`}</p>
                        </label>
                    </div>
                    <BtnTransition hasBackBtn={true} goToBack='/plan' hasNextBtn={true} />
                </form>
            </div>
        </div>
    );
}

export default Addons;